import styled from "styled-components"

const StyledDiv = styled.div`
  width: 100%;
  height: calc(100vh - 50px);
  display: ${({showSideMenu}) => showSideMenu ? "flex" : "block"};
`;

/**
 * @typedef {Object} LocalType
 * @property {boolean} [showSideMenu=true] デフォルト : true
 */

/**
 * 共通「フレーム」
 * @export
 * @param {LocalType & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>} props
 * @return {JSX.Element}
 */
export default function Frame({showSideMenu=true, ...props}) {
  return (
    <StyledDiv {...props} showSideMenu={showSideMenu}/>
  );
}